module.exports = __webpack_public_path__ + "static/media/sea_turtle.aa4bfce4.jpg";